import { FabricObject } from 'fabric';
import { MNEMONIC_FABRIC_PROPERTIES } from './fabric-mnemonic.properties';
import { registerMnemonicChartClass } from '../shapes/mnemonic-chart.class';
import { registerMnemonicGaugeClass } from '../shapes/mnemonic-gauge.class';

let isSerializationConfigured = false;
let isChartClassRegistered = false;
let isGaugeClassRegistered = false;

export function configureMnemonicFabricSerialization(): void {
    if (isSerializationConfigured) {
        return;
    }

    const extraProperties = MNEMONIC_FABRIC_PROPERTIES.filter((property) => !FabricObject.customProperties.includes(property));
    FabricObject.customProperties = [...FabricObject.customProperties, ...extraProperties];
    isSerializationConfigured = true;
}

export function installMnemonicChartSupport(): void {
    if (isChartClassRegistered) {
        return;
    }

    registerMnemonicChartClass();
    isChartClassRegistered = true;
}

export function installMnemonicGaugeSupport(): void {
    if (isGaugeClassRegistered) {
        return;
    }

    registerMnemonicGaugeClass();
    isGaugeClassRegistered = true;
}

export function initializeMnemonicFabricRuntime(): void {
    configureMnemonicFabricSerialization();
    installMnemonicChartSupport();
    installMnemonicGaugeSupport();
}
